import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { randomAvatars } from '@/utils/random-avatar';
export default {
  props: {
    wantToSeeCount: {
      type: Number
    },
    userAvatarList: {
      type: Array
    },
    isCollect: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOverHundredThousand: false,
      showNum: '',
      avatarList: []
    };
  },
  watch: {
    wantToSeeCount: function wantToSeeCount(newValue) {
      this.init();
    }
  },
  mounted: function mounted() {
    this.init(true);
  },
  methods: {
    init: function init(initImg) {
      if (this.wantToSeeCount >= 100000) {
        this.showNum = (this.wantToSeeCount / 10000).toFixed(1);
        this.isOverHundredThousand = true;
      } else {
        var reg = /(?!^)(?=(\d{3})+$)/g;
        this.showNum = (this.wantToSeeCount + '').replace(reg, ',');
      }
      if (initImg) {
        var imgList = this.userAvatarList ? this.userAvatarList.filter(function (item) {
          return item;
        }) : [];
        if (imgList.length < 3) {
          var randomImgNum = 3 - imgList.length;
          var randomImg = randomAvatars(randomImgNum);
          this.avatarList = [].concat(_toConsumableArray(imgList), _toConsumableArray(randomImg));
        } else {
          this.avatarList = _toConsumableArray(imgList);
        }
      }
    },
    handleCollect: function handleCollect() {
      this.$emit('onCollect');
    }
  }
};